module.exports = __webpack_public_path__ + "img/back_list.efd12491.png";